/**
 * FCV跳转到2910的key
 */
export const SESSION_KEY = 'fcvTo2910Path';
/**
 * url里如果有file，则跳转到“创建文件系统”
 */
export enum PathTypeE {
    /** url里如果有file，则跳转到“创建文件系统” */
    File = 'file',
    /** url里如果有assets，则跳转到“新手引导” */
    ASSETS = 'assets'
}
/**
 * 路径映射表
 */
export const PATH_MAP = {
    [PathTypeE.File]: '/service/file/file-system?action=searchCreate',
    [PathTypeE.ASSETS]: '/assets/help/middle/Quickstart/',
};
/**
 * 匹配url里的language
 */
export const LANGUAGE_MATCH = 'language%3D';
